<!--
  支付订单
  lovi 2020-07-07
-->
<template>
  <div class="w100">
    <van-nav-bar
      :title="$t('life.payOrder')"
      :fixed="true"
      left-arrow
      @click-left="_back"
    />
    <div class="scroll-wrapper">
      <scroll>
        <div class="pay-info">
          <p>
            <span>{{ $t("life.remainingTimePay") }}</span>
            <van-count-down
              :time="routeData.time * 1000"
              format="mm:ss"
              @finish="finished"
            />
          </p>
          <h4>{{ routeData.total_price }}P</h4>
          <h3>{{ routeData.shop_name }}</h3>
        </div>
        <!-- 选择支付方式 -->
        <pay-list @getCurPay="getCurPay"></pay-list>
      </scroll>
    </div>

    <div class="button-wrap button-fixed">
      <van-button
        block
        type="primary"
        @click="confirmPayment"
        :disabled="timeEndFlag"
        :loading="btnLoading"
      >
        {{
          timeEndFlag ? $t("life.orderHasTimeout") : $t("common.confirmPayment")
        }}
      </van-button>
    </div>

    <enter-payPsd
      :payPsdFlag.sync="payPsdFlag"
      :data="payPsdData"
      @getPayPsd="lifePayment"
    />
  </div>
</template>

<script>
import _ from "lodash";
import PayList from "@/components/payList";
import EnterPayPsd from "@/components/enterPayPsd";
export default {
  name: "payOrder",
  meta: {
    service: false // 客服
  },
  components: {
    PayList,
    EnterPayPsd
  },
  data() {
    return {
      routeData: {},
      btnLoading: false,
      payPsdFlag: false,
      payPsdData: {
        money: ""
      },
      timeEndFlag: false
    };
  },
  created() {
    let vm = this;
    if (_.isEmpty(vm.$route.params)) {
      // 刷新页面要返回
      vm._back();
    } else {
      vm.routeData = vm.$route.params;
      console.log("routeData", vm.routeData);
    }
  },
  mounted() {},
  computed: {},
  methods: {
    finished() {
      // 倒计时结束
      let vm = this;
      vm.timeEndFlag = true;
      vm.$dialog
        .alert({
          title: vm.$t("life.orderTimeout"),
          message: vm.$t("life.orderTimeoutPlaceNewOrder"),
          confirmButtonText: vm.$t("common.confirm")
        })
        .then(() => {
          // on confirm
          vm.$router.replace({
            path: "/orderDetail",
            name: "orderDetail",
            query: { id: vm.routeData.order_id }
          });
        });
    },
    getCurPay(data) {
      // 获取当前支付信息
      this.curPay = data;
    },
    confirmPayment() {
      // 确认支付
      let vm = this;
      if (vm.curPay.type == 3) {
        // 余额支付
        vm.payPsdData.money = vm.routeData.total_price;
        vm.payPsdFlag = true;
      } else {
        vm.lifePayment();
      }
    },
    pendingPyament() {
      // 支付
      let vm = this;
      vm.$post(
        "/app/pay/pendingPyament",
        {},
        { loading: true, alert: true }
      ).then(res => {
        console.log("cancelOrder", res);
        vm.$toast(res.msg);
        if (res.code == 0) {
          vm.getMyOrder();
        }
      });
    },
    lifePayment(data) {
      // 订单支付提交
      let vm = this;
      let params = {};
      params.total_price = vm.routeData.total_price;
      params.order_id = vm.routeData.order_id;
      params.channel = vm.curPay.type; // 3.余额、5.微信扫码支付
      params.type = vm.curPay.type == 3 ? 1 : vm.curPay.type == 5 ? 2 : "";
      params.pay_password = data;
      vm.$post("/app/pay/lifePayment", params, { loading: true }).then(res => {
        console.log("lifePayment", res);
        let routeData = res;
        if (vm.curPay.type == 3) {
          vm.$router.push({
            path: "/orderDetail",
            name: "orderDetail",
            query: { id: res.order_id }
          });
        }
        if (vm.curPay.type == 5) {
          routeData.money = vm.routeData.total_price;
          vm.$router.push({
            path: "/payCode",
            name: "payCode",
            query: { order: "true", payType: vm.curPay.type },
            params: routeData
          });
        }
      });
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
.scroll-wrapper {
  bottom: 65px;
}
.pay-info {
  padding: 50px 15px;
  text-align: center;
  line-height: 1;
  border-bottom: 10px solid #f4f4f4;
  p {
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  h4 {
    padding: 15px 0;
    font-size: 24px;
    font-weight: 400;
  }
  h3 {
    font-size: 16px;
    font-weight: 400;
  }
}
/deep/.column {
  margin: 0;
  padding: 0 15px;
  box-shadow: none;
  .title {
    padding: 10px 0;
  }
}
</style>
